import React from "react";
import IconTooltip, { IconTooltipType } from "src/components/iconTooltip";
import "./field.scss";

interface IFieldProps {
  className?: string;
  label: React.ReactNode;
  value?: string;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  onBlur?: () => void;
  maxLength?: number;
}

const Field: React.FC<IFieldProps> = ({
  className,
  label,
  value = "",
  onChange,
  placeholder,
  error,
  disabled = false,
  onBlur,
  maxLength,
}) => {
  // Unique per instance: the tooltip id used to be derived from
  // `className`, but most Fields render without one — they all collided
  // on `field-tooltip-undefined`, so a single error icon fired every
  // mounted Field's tooltip at once (duplicate popups).
  const tooltipId = `field-tooltip-${React.useId()}`;

  const fieldClass = `field ${disabled ? "field-disabled" : ""} ${className || ""} ${error ? "field-error" : ""}`;

  return (
    <div className={fieldClass}>
      <label className="field-label">{label}</label>

      <input
        type="text"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        disabled={disabled}
        className="field-input"
        onBlur={onBlur}
        maxLength={maxLength}
      />

      {error && (
        <IconTooltip
          iconType={IconTooltipType.INFO}
          className="icon-tooltip-negative field-icon-tooltip"
          tooltipId={tooltipId}
          tooltipContent={error}
        />
      )}
    </div>
  );
};

export default Field;
